





























import { Component, Vue } from 'vue-property-decorator';
import { AccountApi } from '@/api/account-api';

const api = new AccountApi();

@Component
export default class ChangePasswordForm extends Vue {
    public currentPassword: string | null = null;
    public newPassword: string | null = null;
    public newPasswordConfirmation: string | null = null;

    public get isValid(): boolean {
        return this.currentPassword != null &&
            this.currentPassword.length > 0 &&
            this.newPassword != null &&
            this.newPassword.length > 0 &&
            this.newPasswordConfirmation != null &&
            this.newPasswordConfirmation.length > 0 &&
            this.newPassword === this.newPasswordConfirmation;
    }

    public async submit(): Promise<void> {
        if (!this.isValid) {
            return;
        }

        try {
            await api.changePasswordAsync({ currentPassword: this.currentPassword!, newPassword: this.newPassword! });
        } catch (e) {
            return;
        }

        this.$router.push({ name: 'login' });
    }
}
